export const gigabytesToBytes = (gigabytes: number): number => {
  const bytesInGigabyte = 1024 * 1024 * 1024;
  return gigabytes * bytesInGigabyte;
};

export const megabytesToBytes = (megabytes: number): number => {
  const bytesInMegabyte = 1024 * 1024;
  return megabytes * bytesInMegabyte;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
